import { Component, Input, OnInit } from '@angular/core';
import { GearsApiService } from 'src/app/services/gearsapi.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modelcolour',
  templateUrl: './modelcolour.component.html',
  styleUrls: ['./modelcolour.component.less']
})
export class ModelcolourComponent implements OnInit {
  
  constructor(private apiService:GearsApiService) { }

  @Input() modelid:any;
  @Input() hideColourName:any;
  @Input() hideVehicleImage:any;
  colours:any[] = []
  selected:number = 0;

  select(num:number){
    this.selected = num;
  }
  imgadd(url: string) {
    if (!url.includes('http')) {
      return environment.storageurl + url;
    }
    else {
      return url;
    }

  }
  ngOnInit(): void {
    this.apiService.get('VehicleModelColours',{
      VehicleModelID_FK:this.modelid
    }).then((x:any)=>{
      this.colours=x.body;
    });
  }

}
